var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,6.5H15.5V3A2.5009,2.5009,0,0,0,13,.5H3A2.5009,2.5009,0,0,0,.5,3V21A2.5009,2.5009,0,0,0,3,23.5H13A2.5009,2.5009,0,0,0,15.5,21V17.5H22A1.498,1.498,0,0,0,23.5,16V8A1.498,1.498,0,0,0,22,6.5Zm-11.81-5-.5,1H6.31l-.5-1ZM14.5,21A1.498,1.498,0,0,1,13,22.5H3A1.498,1.498,0,0,1,1.5,21V19.5h13Zm0-2.5H1.5V3A1.498,1.498,0,0,1,3,1.5H4.69l.86,1.72A.5118.5118,0,0,0,6,3.5h4a.5118.5118,0,0,0,.45-.28l.86-1.72H13A1.498,1.498,0,0,1,14.5,3V6.5H8A1.498,1.498,0,0,0,6.5,8v8A1.498,1.498,0,0,0,8,17.5h6.5Zm8-2.5a.4951.4951,0,0,1-.5.5H8a.4951.4951,0,0,1-.5-.5V8A.4951.4951,0,0,1,8,7.5H22a.4951.4951,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,9.5a.5.5,0,0,0-.5.5v2.5L9.9,9.7A.5.5,0,0,0,9,10v4a.5.5,0,0,0,1,0V11.5l2.1,2.8a.5014.5014,0,0,0,.4.2.4923.4923,0,0,0,.1582-.0259A.4994.4994,0,0,0,13,14V10A.5.5,0,0,0,12.5,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,10.5a.5.5,0,0,0,0-1h-2a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,1,0V12.5h1.5a.5.5,0,0,0,0-1H15v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,10.5h1a.5.5,0,0,0,0-1h-1A1.5017,1.5017,0,0,0,18,11v2a1.5017,1.5017,0,0,0,1.5,1.5h1a.5.5,0,0,0,0-1h-1A.5006.5006,0,0,1,19,13V11A.5006.5006,0,0,1,19.5,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3.5a3.1,3.1,0,0,0-2.3994,1.1987.5.5,0,0,0,.7988.6026A1.999,1.999,0,0,1,21.6,5.3.5005.5005,0,0,0,22.4,4.7,3.0886,3.0886,0,0,0,20,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,3.2993A.5.5,0,0,0,23.3,2.6a5.5,5.5,0,0,0-6.6,0,.5.5,0,0,0,.6.8008,4.546,4.546,0,0,1,2.6621-.9h.0371A4.5461,4.5461,0,0,1,22.7,3.4.5.5,0,0,0,23.4,3.2993Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfc);
export default __webpack_public_path__ + "static/media/nfc.5a0ac3e3.svg";
export { ForwardRef as ReactComponent };